import React from 'react';
import Users from './Users';

const PatientData = () => {
  return <Users filter="patients" />;
};

export default PatientData;
